import React from 'react';
import { Tab, TabButtonStyle, TabKeyIdentifierPrefix, TabPanel, TabPanelBorderRadius, TabPanelTheme } from '@apply/components';
import { DemoSection } from './common/SectionNavigator';
import { DemoExample, DemoPage, DemoPageSection } from './common/DemoLayout';

const sections: DemoSection[] = [
    { id: 'tabPanelDemo_blue', title: 'Blue' },
    { id: 'tabPanelDemo_red', title: 'Red' },
    { id: 'tabPanelDemo_white', title: 'White' },
    { id: 'tabPanelDemo_grey', title: 'Grey' },
    { id: 'tabPanelDemo_whiteout', title: 'Whiteout' },
    { id: 'tabPanelDemo_bluecondensed', title: 'Blue (Condensed)' },
    { id: 'tabPanelDemo_redcondensed', title: 'Red (Condensed)' },
    { id: 'tabPanelDemo_whitecondensed', title: 'White (Condensed)' },
    { id: 'tabPanelDemo_greycondensed', title: 'Grey (Condensed)' },
];

export const TabPanelDemo: React.FC = () => {
    return (
        <DemoPage
            title='Tab Panel :'
            sections={sections}
        >
            <DemoPageSection id={sections[0].id}>
                <DemoExample label='Blue Tab Panel'>
                    <TabPanel
                        id='tabPanelDemo'
                        theme={TabPanelTheme.Blue}
                        width='100%'
                    >
                        <Tab
                            id='item1'
                            text='Item 1'
                            key={`${TabKeyIdentifierPrefix}1`}
                        >
                            This is children for item 1.
                        </Tab>
                        <Tab
                            id='item2'
                            text='Item 2'
                            key={`${TabKeyIdentifierPrefix}2`}
                        >
                            This is children for item 2.
                        </Tab>
                        <Tab
                            id='item3'
                            text='Item 3'
                            key={`${TabKeyIdentifierPrefix}3`}
                        >
                            This is children for item 3.
                        </Tab>
                        <Tab
                            id='item4'
                            text='Item 4'
                            key={`${TabKeyIdentifierPrefix}4`}
                        >
                            This is children for item 4.
                        </Tab>
                    </TabPanel>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[1].id}>
                <DemoExample label='Red Tab Panel'>
                    <TabPanel
                        id='tabPanelDemo'
                        theme={TabPanelTheme.Red}
                        width='100%'
                    >
                        <Tab
                            id='item1'
                            text='Item 1'
                            key={`${TabKeyIdentifierPrefix}1`}
                        >
                            This is children for item 1.
                        </Tab>
                        <Tab
                            id='item2'
                            text='Item 2'
                            key={`${TabKeyIdentifierPrefix}2`}
                        >
                            This is children for item 2.
                        </Tab>
                        <Tab
                            id='item3'
                            text='Item 3'
                            key={`${TabKeyIdentifierPrefix}3`}
                        >
                            This is children for item 3.
                        </Tab>
                        <Tab
                            id='item4'
                            text='Item 4'
                            key={`${TabKeyIdentifierPrefix}4`}
                        >
                            This is children for item 4.
                        </Tab>
                    </TabPanel>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[2].id}>
                <DemoExample label='White Tab Panel'>
                    <TabPanel
                        id='tabPanelDemo'
                        theme={TabPanelTheme.White}
                        width='100%'
                    >
                        <Tab
                            id='item1'
                            text='Item 1'
                            key={`${TabKeyIdentifierPrefix}1`}
                        >
                            This is children for item 1.
                        </Tab>
                        <Tab
                            id='item2'
                            text='Item 2'
                            key={`${TabKeyIdentifierPrefix}2`}
                        >
                            This is children for item 2.
                        </Tab>
                        <Tab
                            id='item3'
                            text='Item 3'
                            key={`${TabKeyIdentifierPrefix}3`}
                        >
                            This is children for item 3.
                        </Tab>
                        <Tab
                            id='item4'
                            text='Item 4'
                            key={`${TabKeyIdentifierPrefix}4`}
                        >
                            This is children for item 4.
                        </Tab>
                    </TabPanel>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[3].id}>
                <DemoExample label='Grey Tab Panel'>
                    <TabPanel
                        id='tabPanelDemo'
                        theme={TabPanelTheme.Gray}
                        width='100%'
                    >
                        <Tab
                            id='item1'
                            text='Item 1'
                            key={`${TabKeyIdentifierPrefix}1`}
                        >
                            This is children for item 1.
                        </Tab>
                        <Tab
                            id='item2'
                            text='Item 2'
                            key={`${TabKeyIdentifierPrefix}2`}
                        >
                            This is children for item 2.
                        </Tab>
                        <Tab
                            id='item3'
                            text='Item 3'
                            key={`${TabKeyIdentifierPrefix}3`}
                        >
                            This is children for item 3.
                        </Tab>
                        <Tab
                            id='item4'
                            text='Item 4'
                            key={`${TabKeyIdentifierPrefix}4`}
                        >
                            This is children for item 4.
                        </Tab>
                    </TabPanel>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[4].id}>
                <DemoExample label='"Whiteout" Tab Panel'>
                    <TabPanel
                        id='tabPanelDemo'
                        theme={TabPanelTheme.Whiteout}
                        width='100%'
                    >
                        <Tab
                            id='item1'
                            text='Item 1'
                            key={`${TabKeyIdentifierPrefix}1`}
                        >
                            This is children for item 1.
                        </Tab>
                        <Tab
                            id='item2'
                            text='Item 2'
                            key={`${TabKeyIdentifierPrefix}2`}
                        >
                            This is children for item 2.
                        </Tab>
                        <Tab
                            id='item3'
                            text='Item 3'
                            key={`${TabKeyIdentifierPrefix}3`}
                        >
                            This is children for item 3.
                        </Tab>
                        <Tab
                            id='item4'
                            text='Item 4'
                            key={`${TabKeyIdentifierPrefix}4`}
                        >
                            This is children for item 4.
                        </Tab>
                    </TabPanel>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[5].id}>
                <DemoExample label='Blue Tab Panel'>
                    <TabPanel
                        id='tabPanelDemo'
                        theme={TabPanelTheme.Blue}
                        width='100%'
                        tabButtonStyle={TabButtonStyle.Condensed}
                        tabPanelBorderRadius={TabPanelBorderRadius.Small}
                    >
                        <Tab
                            id='item1'
                            text='Item 1'
                            key={`${TabKeyIdentifierPrefix}1`}
                        >
                            This is children for item 1.
                        </Tab>
                        <Tab
                            id='item2'
                            text='Item 2'
                            key={`${TabKeyIdentifierPrefix}2`}
                        >
                            This is children for item 2.
                        </Tab>
                        <Tab
                            id='item3'
                            text='Item 3'
                            key={`${TabKeyIdentifierPrefix}3`}
                        >
                            This is children for item 3.
                        </Tab>
                        <Tab
                            id='item4'
                            text='Item 4'
                            key={`${TabKeyIdentifierPrefix}4`}
                        >
                            This is children for item 4.
                        </Tab>
                    </TabPanel>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[6].id}>
                <DemoExample label='Red Tab Panel'>
                    <TabPanel
                        id='tabPanelDemo'
                        theme={TabPanelTheme.Red}
                        width='100%'
                        tabButtonStyle={TabButtonStyle.Condensed}
                        tabPanelBorderRadius={TabPanelBorderRadius.Small}
                    >
                        <Tab
                            id='item1'
                            text='Item 1'
                            key={`${TabKeyIdentifierPrefix}1`}
                        >
                            This is children for item 1.
                        </Tab>
                        <Tab
                            id='item2'
                            text='Item 2'
                            key={`${TabKeyIdentifierPrefix}2`}
                        >
                            This is children for item 2.
                        </Tab>
                        <Tab
                            id='item3'
                            text='Item 3'
                            key={`${TabKeyIdentifierPrefix}3`}
                        >
                            This is children for item 3.
                        </Tab>
                        <Tab
                            id='item4'
                            text='Item 4'
                            key={`${TabKeyIdentifierPrefix}4`}
                        >
                            This is children for item 4.
                        </Tab>
                    </TabPanel>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[7].id}>
                <DemoExample label='White Tab Panel'>
                    <TabPanel
                        id='tabPanelDemo'
                        theme={TabPanelTheme.White}
                        width='100%'
                        tabButtonStyle={TabButtonStyle.Condensed}
                        tabPanelBorderRadius={TabPanelBorderRadius.Small}
                    >
                        <Tab
                            id='item1'
                            text='Item 1'
                            key={`${TabKeyIdentifierPrefix}1`}
                        >
                            This is children for item 1.
                        </Tab>
                        <Tab
                            id='item2'
                            text='Item 2'
                            key={`${TabKeyIdentifierPrefix}2`}
                        >
                            This is children for item 2.
                        </Tab>
                        <Tab
                            id='item3'
                            text='Item 3'
                            key={`${TabKeyIdentifierPrefix}3`}
                        >
                            This is children for item 3.
                        </Tab>
                        <Tab
                            id='item4'
                            text='Item 4'
                            key={`${TabKeyIdentifierPrefix}4`}
                        >
                            This is children for item 4.
                        </Tab>
                    </TabPanel>
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection id={sections[8].id}>
                <DemoExample label='Grey Tab Panel'>
                    <TabPanel
                        id='tabPanelDemo'
                        theme={TabPanelTheme.Gray}
                        width='100%'
                        tabButtonStyle={TabButtonStyle.Condensed}
                        tabPanelBorderRadius={TabPanelBorderRadius.Small}
                    >
                        <Tab
                            id='item1'
                            text='Item 1'
                            key={`${TabKeyIdentifierPrefix}1`}
                        >
                            This is children for item 1.
                        </Tab>
                        <Tab
                            id='item2'
                            text='Item 2'
                            key={`${TabKeyIdentifierPrefix}2`}
                        >
                            This is children for item 2.
                        </Tab>
                        <Tab
                            id='item3'
                            text='Item 3'
                            key={`${TabKeyIdentifierPrefix}3`}
                        >
                            This is children for item 3.
                        </Tab>
                        <Tab
                            id='item4'
                            text='Item 4'
                            key={`${TabKeyIdentifierPrefix}4`}
                        >
                            This is children for item 4.
                        </Tab>
                    </TabPanel>
                </DemoExample>
            </DemoPageSection>
        </DemoPage>
    );
};
